import { useEffect, useState } from "react";
import "swiper/css";
import "swiper/css/scrollbar";

import RegisterStep1 from "@assets/svg/Register-step1.svg?react";
import RegisterStep2 from "@assets/svg/Register-step2.svg?react";
import RegisterStep3 from "@assets/svg/Register-step3.svg?react";

import {
  DescriptionSectionWrapper,
  ImageStyled,
  TextWrapper,
  TitleText,
  DescriptionText,
  IndicatorWrapper,
  Indicator,
} from "./styles";
import { useTranslation } from "react-i18next";

export default function Slider() {
  const { t } = useTranslation();
  const [slide, setSlide] = useState(1);

  const svgList = [RegisterStep1, RegisterStep2, RegisterStep3];

  useEffect(() => {
    const interval = setInterval(() => {
      setSlide((prev) => (prev < svgList.length ? prev + 1 : 1));
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  function handleTitle() {
    switch (slide) {
      case 1:
        return t("Signup.unified_inbox");
      case 2:
        return t("Signup.full_automation_for_all_operations");
      case 3:
        return t("Signup.calendar");
      default:
        return "";
    }
  }

  const CurrentSvg = svgList[slide - 1];

  return (
    <DescriptionSectionWrapper>
      <ImageStyled as={CurrentSvg} />
      <TextWrapper>
        <TitleText>{handleTitle()}</TitleText>
        <DescriptionText>{t("Signup.description")}</DescriptionText>
        <IndicatorWrapper>
          {svgList.map((_, index) => (
            <Indicator key={index} active={slide === index + 1} />
          ))}
        </IndicatorWrapper>
      </TextWrapper>
    </DescriptionSectionWrapper>
  );
}
